import { useClubSettings } from "apps/portal/src/providers";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { CreditPackItemType } from "../CreditPackItem";

type CreditPackExpiryInfoProps = {
  creditPack: CreditPackItemType;
};

export const CreditPackExpiryInfo = ({
  creditPack,
}: CreditPackExpiryInfoProps) => {
  const { t } = useTranslation();
  const {
    club: { timezone },
  } = useClubSettings();
  const { status, expiryDate, partOfMembership } = creditPack;

  const shouldShowExpiryInfo =
    !(status === "PENDING" && partOfMembership) &&
    status !== "CANCELLED" &&
    status !== "EXPIRED";

  if (shouldShowExpiryInfo) {
    return (
      <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
        {expiryDate
          ? t("components.creditPackItem.expiry", {
              expiryDate: DateTime.fromISO(expiryDate)
                .setZone(timezone)
                .toLocaleString(DateTime.DATE_MED),
            })
          : t("components.creditPackItem.noExpiryDate")}
      </div>
    );
  }

  if (status === "EXPIRED") {
    return (
      <div className="text-sm font-medium text-gray-500 dark:text-gray-400">
        {expiryDate
          ? t("components.creditPackItem.expired", {
              expiredDate: DateTime.fromISO(expiryDate)
                .setZone(timezone)
                .toLocaleString(DateTime.DATE_MED),
            })
          : t("components.creditPackItem.noExpiredDate")}
      </div>
    );
  }

  return null;
};
